import LOGO from "../images/llamas.png";

export const Team__Llamas = {
  name: "Llamas",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#f561e3ff",
  teamJerseyColor: "#31A0BC",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 23 + 22 + 54,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 31 + 41 + 46,
    },
  ],
};
